import {styled} from '../../../utils';

export default styled('header')({
  boxSizing: 'border-box',
  flexShrink: 0
});



// WEBPACK FOOTER //
// ./src/components/Layout/Header/Header.tsx